module.exports = __webpack_public_path__ + "static/Olympo310-0fa6659cdd23f4b66440df1bc066ec05.mp4";